import React from "react";
import AdminAddUser from "../../Components/Admin/AdminAddUser";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddUserPage = ()=>{
    return (
        <div className="d-flex justify-content-start">
        <div>
          <SideBar />
        </div>
        <div className="p-4" style={{ width: '100%' }}>
          <AdminAddUser />
        </div>
      </div>
    )
}

export default AdminAddUserPage